<template>
    <out-put-page title="Étude financière">
        <section>
            <div class="mb-4">
                <h3>
                    Programme d'investissement (HT)
                </h3>
                <div class="grid grid-cols-2">
                    <VueApexCharts
                        class=""
                        type="donut"
                        :series="investorProgrammeSeries"
                        :options="investorProgrammeOptions"
                        height="550px"
                    />
                    <div class="flex flex-col mx-8 space-y-3">
                        <div class="flex flex-col">
                            <div
                                class="flex items-center justify-center p-2 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Immobilisations en non-valeur
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    {{
                                        formatPrice(
                                            investorProgramme.nonValueAssetTotal
                                        )
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-2 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Immobilisations corporelles
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{
                                        formatPrice(
                                            investorProgramme.tangibleAssetsTotal
                                        )
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-2 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Immobilisations incorporelles
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{
                                        formatPrice(
                                            investorProgramme.intangibleAssetsTotal
                                        )
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-2 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Divers et imprévue
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{
                                        investorProgramme.diversImprevue
                                            ? formatPrice(
                                                  investorProgramme.diversImprevue
                                              )
                                            : 0
                                    }}
                                </h4>
                            </div>
                        </div>
                        <div class="flex flex-col ">
                            <div
                                class="flex items-center justify-center p-2 bg-output-primary"
                            >
                                <h4 class="text-2xl font-semibold text-white">
                                    Total
                                </h4>
                            </div>
                            <div
                                class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                            >
                                <h4>
                                    {{ formatPrice(investorsProgrammeTotal) }}
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <h3>
                    Plan de Financement(HT)
                </h3>
                <div class="flex flex-col ">
                    <div class="grid items-center grid-cols-2 gap-6">
                        <VueApexCharts
                            class="mt-4 "
                            type="donut"
                            :series="seriesPlanFinancement"
                            :options="optionsPlanFinancement"
                            height="550px"
                        />
                        <div class="flex flex-col space-y-3">
                            <div class="flex flex-col">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        CAPITAL SOCIAL
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[0]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        APPORT EN COMPTES COURANTS ASSOCIÉS
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[1]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        CRÉDIT BANCAIRE
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[2]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        Leasing
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[3]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        Subventions
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement[4]
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                            <div class="flex flex-col ">
                                <div
                                    class="flex items-center justify-center p-2 bg-output-primary"
                                >
                                    <h4
                                        class="text-2xl font-semibold text-white"
                                    >
                                        TOTAL
                                    </h4>
                                </div>
                                <div
                                    class="flex items-center justify-center p-2 text-2xl text-white bg-output-blue-300"
                                >
                                    <h4>
                                        {{
                                            formatPrice(
                                                seriesPlanFinancement.reduce(
                                                    (a, b) => a + b
                                                )
                                            )
                                        }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <stylish-table :table="{}" /> -->
        </section>
    </out-put-page>
</template>

<script>
import OutPutPage from "../components/OutPutPage";
import VueApexCharts from "vue-apexcharts";
import { OutputHelpers } from "@/mixins/OutputMixin.js";

export default {
    name: "pi-and-pf",
    components: {
        OutPutPage,
        VueApexCharts
    },
    props: {
        investorProgramme: {
            type: Object,
            required: true
        }
    },
    mixins: [OutputHelpers],

    mounted() {
        this.investorProgrammeSeries.push(
            this.investorProgramme.nonValueAssetTotal
        );
        this.investorProgrammeSeries.push(
            this.investorProgramme.tangibleAssetsTotal
        );
        this.investorProgrammeSeries.push(
            this.investorProgramme.intangibleAssetsTotal
        );
        this.investorProgrammeSeries.push(
            this.investorProgramme?.diversImprevue ?? 0
        );
        this.seriesPlanFinancement.push(
            this.investorProgramme?.capitalSocial ?? 0
        );
        this.seriesPlanFinancement.push(
            this.investorProgramme?.compteAssocie ?? 0
        );

        //temp variable for compatibility reasons
        const creditBancaireTemp = Array.isArray(
            this.investorProgramme.creditBancaire
        )
            ? this.investorProgramme.creditBancaire
            : [this.investorProgramme.creditBancaire];
        console.log(
            "🚀 ~ file: PIAndPFVD.vue ~ line 320 ~ mounted ~ creditBancaireTemp",
            creditBancaireTemp
        );
        const creditBancaire = creditBancaireTemp.reduce((sum, credit) => {
            if (!credit.montant || credit.montant !== 0)
                return credit.montant + sum;
            return sum;
        }, 0);

        this.seriesPlanFinancement.push(creditBancaire);

        this.seriesPlanFinancement.push(this.investorProgramme?.leasing ?? 0);
        this.seriesPlanFinancement.push(
            this.investorProgramme?.subventions ?? 0
        );
    },
    data() {
        return {
            investorProgrammeOptions: {
                labels: [
                    "Immobilisations en non-valeur",
                    "Immobilisations corporelles",
                    "Immobilisations incorporelles",
                    "Divers et imprevue"
                ],
                colors: ["#009fe3", "#1a9dd9", "#14b5ea", "#84d0f5", "#0d406b"],
                chart: {
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        // customScale: 0.3,
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter(val, opts) {
                        const name = opts.w.globals.labels[opts.seriesIndex];
                        return [name, val.toFixed(1) + "%"];
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    },
                    position: "bottom",
                    fontSize: "16px",
                    fontFamily: "Cormorant Garamond",
                    fontWeight: 400,
                    show: false
                }
            },
            investorProgrammeSeries: [],
            optionsPlanFinancement: {
                labels: [
                    "Capital social",
                    "Apport en comptes courants associés",
                    "Leasing",
                    "Subventions",
                    "Crédit bancaire"
                ],
                colors: ["#009fe3", "#1a9dd9", "#14b5ea", "#84d0f5", "#0d406b"],
                chart: {
                    type: "pie"
                },
                plotOptions: {
                    pie: {
                        // customScale: 0.3,
                        donut: {
                            labels: {
                                show: false,
                                name: {},
                                total: {
                                    show: true,
                                    label: "Total",
                                    color: "#373d3f",
                                    formatter: function(w) {
                                        return w.globals.seriesTotals.reduce(
                                            (a, b) => {
                                                return a + b;
                                            },
                                            0
                                        );
                                    }
                                }
                            }
                        }
                    }
                },
                dataLabels: {
                    formatter(val, opts) {
                        const name = opts.w.globals.labels[opts.seriesIndex];
                        return [name, val.toFixed(1) + "%"];
                    }
                },
                legend: {
                    formatter: function(seriesName, opts) {
                        return [
                            seriesName,
                            " - ",
                            opts.w.globals.series[opts.seriesIndex],
                            " DH"
                        ];
                    },
                    position: "bottom",
                    fontSize: "16px",
                    fontFamily: "Cormorant Garamond",
                    fontWeight: 400,
                    show: false
                }
            },
            seriesPlanFinancement: []
        };
    },
    computed: {
        investorsProgrammeTotal() {
            let total = 0;
            if (this.investorProgramme.diversImprevue !== null)
                total += this.investorProgramme.diversImprevue;

            if (this.investorProgramme.tangibleAssetsTotal !== null)
                total += this.investorProgramme.tangibleAssetsTotal;
            if (this.investorProgramme.intangibleAssetsTotal !== null)
                total += this.investorProgramme.intangibleAssetsTotal;

            if (this.investorProgramme.nonValueAssetTotal !== null)
                total += this.investorProgramme.nonValueAssetTotal;

            return total;
        }
    },
    methods: {}
};
</script>

<style></style>
